

































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import AbpBase from "../../lib/abpbase";
import BuyCardRecord from "../../store/entities/booking/buyCardRecord";
import MultiPicture from "../../components/multi-picture.vue";
import RegionSelect from "../../components/region-select.vue";
import CourtSelect from "../../components/court-select.vue";
import Ajax from "@/lib/ajax";

@Component({
  components: { RegionSelect, MultiPicture, CourtSelect },
})
export default class CreateCouponCourt extends AbpBase {
  @Prop({ type: Boolean, default: false })
  value: boolean;
  buyCardRecord: BuyCardRecord = new BuyCardRecord();
  type: boolean = false;
   sexList: Array<any> = [
    {
      value: 1,
      label: "男",
    },
    {
      value:2,
      label: "女",
    },
  ];

  async save() {
    if (!this.buyCardRecord.name) {
      this.$Message.error("请输入姓名");
    }
    if (!this.buyCardRecord.mobile) {
      this.$Message.error("请输入手机号");
    }

    await this.$store.dispatch({
      type: "buyCardRecord/createReocrd",
      data: this.buyCardRecord,
    });
    this.$emit("save-success");
    this.$emit("input", false);
  }
  cancel() {
    (this.$refs.couponCourtForm as any).resetFields();
    this.$emit("input", false);
  }
  visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
    }
  }
  validateCourtId(rule, value, callback) {
    if (!value) {
      return callback(new Error("请选择球场"));
    } else {
      callback();
    }
  }
  validateCouponId(rule, value, callback) {
    if (!value) {
      return callback(new Error("请选择优惠券"));
    } else {
      callback();
    }
  }
  async created() {
   
  }
}
